var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-icon btn-light-danger btn-sm rounded-sm px-5"},[_c('i',{staticClass:"icon-sm fas fa-trash"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }